import {
  AloftPrice,
  PairedCostAdjustmentType,
  PairedCostPropertyResult,
  PairedCostResults,
  SegmentCostType,
  isDefined,
} from '@aloft/toolkit-shared';

const adjToSegmentCostsMap: Record<PairedCostAdjustmentType, SegmentCostType[]> = {
  termsOfSale: [],
  concessions: [],
  dateOfSale: [],
  site: [],
  quality: [],
  condition: [],
  mainDwelling: ['mainDwelling'],
  bathAboveGrade: [],
  bathBelowGrade: [],
  basement: ['basement'],
  functionalUtility: [],
  externalObsolescence: [],
  garageCarport: ['attachedOrBuiltinGarage', 'detachedGarage', 'carport'],
  porchPatioDeck: ['coveredPatioOrGazebo', 'enclosedPatio', 'deck'],
  attic: ['attic'],
  fireplace: [],
  belowGradeANSI: ['belowGradeANSI'],
  barn: ['barn'],
  bonusRoom: ['bonusRoom'],
  adu: ['adu'],
  manufactured: ['manufactured'],
  pool: ['pool'],
  shed: ['shed'],
  workshop: ['workshop'],
  manual: ['manual'],
  locationView: [],
  foundation: [],
  units: [],
};

const getAdjCategoryCost = (
  property: PairedCostPropertyResult | undefined,
  adjustmentType: PairedCostAdjustmentType,
): AloftPrice =>
  Object.entries(property?.segmentCosts ?? {})
    .filter(
      ([segment, cost]) =>
        adjToSegmentCostsMap[adjustmentType].includes(segment as SegmentCostType) &&
        isDefined(cost?.totalCost),
    )
    .map(([_segment, cost]) => cost.totalCost)
    .reduce((acc, curr) => acc.add(curr), AloftPrice.zero);

export const isCosted = (results: PairedCostResults, adjustmentType: PairedCostAdjustmentType) => {
  const subjectCost = getAdjCategoryCost(results.subject, adjustmentType);
  const comps = Object.values(results.comps).map((comp) =>
    getAdjCategoryCost(comp, adjustmentType),
  );

  const hasSubjCost = subjectCost.gt(AloftPrice.zero);
  const hasCompCost = Object.values(comps).filter((comp) => comp.gt(AloftPrice.zero)).length > 0;

  return hasSubjCost || hasCompCost;
};
